import styled from 'styled-components';
import { color } from 'styles/settings';

export const Arrow = styled.span`
  position: absolute;
  cursor: pointer;
  border-left: 2px solid ${color.brand.gold};
  margin-right: 2px;
  pointer-events: auto;
  z-index: 1;

  :before {
    position: absolute;
    content: '';
    display: block;
    top: 50%;
    transform: translate(-50%, -50%);
    left: -4px;
    border-top: 8px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid
      ${({ isNote }) => (isNote ? color.neutral.white : color.brand.gold)};
  }
`;
